import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { debounceTime, filter, map } from 'rxjs';

import { selectIsLinearBetslip } from '../../../base/store/selectors';
import { IBetslipRootState } from '../../../base/store/state';
import BetslipPickActions from '../../picks/actions';
import { betslipPicksListCountSelector } from '../../picks/selectors';
import BetslipSystemBetActions from '../actions';
import { systemBetPickOddStateSelector } from '../selectors';
import SystemBetTypesCalculatorService from '../services/types/system-bet-types-calculator.service';

@Injectable()
export default class SystemBetLinearEffects {
    constructor(
        private actions$: Actions,
        private store: Store<IBetslipRootState>,
        private typesCalculatorService: SystemBetTypesCalculatorService,
    ) {}

    handleAvailableSystemTypesChange$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(
                BetslipPickActions.addPick,
                BetslipPickActions.replacePick,
                BetslipPickActions.removeMultiplePicks,
                BetslipPickActions.removePick,
                BetslipPickActions.togglePick,
                BetslipSystemBetActions.toggleSystemBetPick,
                BetslipPickActions.toggleAllPicks,
                BetslipPickActions.changeLockState,
                BetslipSystemBetActions.toggleSystemBetPickBanker,
                BetslipSystemBetActions.toggleSystemBanker,
                BetslipSystemBetActions.addPick,
                BetslipSystemBetActions.removePick,
            ),
            debounceTime(5),
            concatLatestFrom(() => [this.store.select(systemBetPickOddStateSelector), this.store.select(selectIsLinearBetslip)]),
            filter(([, picks, isLinear]) => picks && isLinear),
            map(([, picks, isLinear]) => {
                const types = this.typesCalculatorService.calculateAvailableTypes(picks, isLinear);
                const slipTypes = types.map((type) => ({ type: type.typeInfo.slipType, betCount: type.typeInfo.betCount }));

                return BetslipSystemBetActions.updateSystemTypeStakes({ systemTypes: slipTypes });
            }),
        );
    });

    resetSystemModuleExpanded$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipPickActions.removePick, BetslipPickActions.removeMultiplePicks),
            concatLatestFrom(() => this.store.select(selectIsLinearBetslip)),
            filter(([_, isLinear]) => isLinear),
            concatLatestFrom(() => this.store.select(betslipPicksListCountSelector)),
            filter(([_, picksCount]) => picksCount === 0),
            map(() => BetslipSystemBetActions.toggleExpandLinearSystemBet({ isExpanded: false })),
        );
    });

    handleSystemBetExpandClicked$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipSystemBetActions.clickExpandLinearSystemBet),
            concatLatestFrom(() => this.store.select(selectIsLinearBetslip)),
            filter(([_, isLinear]) => isLinear),
            map(([action]) => BetslipSystemBetActions.toggleExpandLinearSystemBet({ isExpanded: action.isExpanded })),
        );
    });
}
